const Data = [
  {
    tag: "Twitter",
    id: "twitter",
    link: "https://www.twitter.com/TegaDev",
    target: "_blank",
    rel: "noreferrer",
  },
  {
    tag: "LinkedIn",
    id: "btn__linkedIn",
    link: "https://www.linkedin.com/in/tega-akpovbiyor",
    target: "_blank",
    rel: "noreferrer",
  },
  // {
  //   tag: "Zuri Team",
  //   id: "btn__zuri",
  //   link: "https://training.zuri.team",
  //   target: "_blank",
  //   rel: "noreferrer",
  // },
  {
    tag: "Github",
    id: "github",
    link: "http://www.github.com/heytega",
    target: "_blank",
    rel: "noreferrer",
  },
  // {
  //   tag: "Zuri Books",
  //   id: "books",
  //   link: "http://books.zuri.team",
  //   target: "_blank",
  //   rel: "noreferrer",
  // },
  // {
  //   tag: "Python Books",
  //   id: "book__python",
  //   link: "https://books.zuri.team/python-for-beginners?ref_id=Akpovbiyor",
  //   target: "_blank",
  //   rel: "noreferrer",
  // },
  // {
  //   tag: "Background Check for Coders",
  //   id: "pitch",
  //   link: "https://background.zuri.team/",
  //   target: "_blank",
  //   rel: "noreferrer",
  // },
  // {
  //   tag: "Design Books",
  //   id: "book__design",
  //   link: "https://books.zuri.team/design-rules",
  //   target: "_blank",
  //   rel: "noreferrer",
  // },
  {
    tag: "Contact Me",
    id: "contact",
    link: "/contact",
    target: "",
    rel: "",
  },
];

export default Data;
